import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'helpers/translator'

import Confirm from 'views/confirm/confirm'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import cartActions from 'redux/actions/cartActions'
import generalActions from 'redux/actions/generalActions'

const CONFIRM_TYPE = confirmTypes.CART_REMOVE

const CartRemoveConfirm = props => (<Confirm
	btOne={localize('global_no')}
	btTwo={localize('global_yes')}
	alertTitle={''}
	alertMessage={localize('cart_remove_alert')}
	actionButtonType={1}
	actionOne={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	actionTwo={
		() => {
			props.actions.toggleCart(props.entityUID, props.entityType, true)
			props.actions.closeConfirm(CONFIRM_TYPE)
		}
	}
	closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
/>)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		toggleCart: cartActions.toggleCart,
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CartRemoveConfirm)
